import { render, staticRenderFns } from "./EditSectionInstallments.vue?vue&type=template&id=2ed77e4d&scoped=true&"
import script from "./EditSectionInstallments.vue?vue&type=script&lang=js&"
export * from "./EditSectionInstallments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed77e4d",
  null
  
)

export default component.exports